module.exports = __webpack_public_path__ + "img/PGYER.3ac59b9e.png";